/**
 * Generated schema types for onboarding service
 * This file contains DTOs and enums used by the onboarding API
 */

export interface FindOrCreateTutorialDto {
  name: string
}

export enum TutorialResponseDtoState {
  pending = 'pending',
  completed = 'completed'
}

export interface TutorialResponseDto {
  id: number
  userId: number
  name: string
  state: TutorialResponseDtoState
  createdAt: string
  updatedAt: string
}

export enum UpdateTutorialDtoAction {
  CONSUME = 'CONSUME',
  DISMISS = 'DISMISS',
  COMPLETE = 'COMPLETE'
}

export interface UpdateTutorialDto {
  id: number
  action: UpdateTutorialDtoAction
}
